module.exports = __webpack_public_path__ + "static/media/login_bm.f7340861.jpg";